import { Location } from "history";
import { createSearchParams } from "react-router-dom-v5-compat";

import { SpeedyMarkingMode } from "features/teachers/pages/assignment/components/SpeedyMarking/SpeedyMarkingSession";

import { linkToAssignmentPage } from "../assignments/links";

export function linkToAssignmentSpeedyMarking(
  classId?: string,
  assignmentId?: string,
  search?: {
    mode: SpeedyMarkingMode;
  },
  state?: {
    selectedQuestionIds: string[];
  }
) {
  return {
    pathname: `${linkToAssignmentPage(classId, assignmentId)}/speedy-marking`,
    search: `?${createSearchParams({ mode: search?.mode ?? "" })}`,
    state
  } as Location;
}
